import React, { useState, useEffect, useCallback } from 'react';

import AuthUserContext from './context';
import { withFirebase } from '../Firebase';

const withAuthentication = (Component) => {
    const WithAuthentication = (props) => {
        const { firebase } = props;
        const [authUser, setAuthUser] = useState(null);
        const [incoterms, setIncoterms] = useState([]);
        useEffect(() => {
            const listener = firebase.onAuthUserListener(
                (authUser) => {
                    setAuthUser(authUser);
                },
                () => {
                    setAuthUser(null);
                }
            );
            return () => {
                // remove listener
                listener();
            };
        }, [firebase]);

        const getIncoterms = useCallback(() => {
            return firebase.getAllRecursive('incoterms').then((incoterms) => {
                setIncoterms(incoterms);
            });
        }, [firebase]);

        useEffect(() => {
            getIncoterms();
        }, [getIncoterms]);

        const updateUserSettings = (settings) => {
            setAuthUser((curAuthUser) => {
                curAuthUser.settings = settings;
                return { ...curAuthUser };
            });
        };

        return (
            <AuthUserContext.Provider value={{ authUser, updateUserSettings, incoterms }}>
                <Component {...props} />
            </AuthUserContext.Provider>
        );
    };

    return withFirebase(WithAuthentication);
};

export default withAuthentication;
